export enum ZenAIDomain {
  Violations = 'violations',
}

export enum ZenAIStreamEventType {
  Reasoning = 'reasoning',
  Complete = 'complete',
  Error = 'error',
}

export interface ZenAIQueryRequest {
  domain: ZenAIDomain;
  prompt: string;
  sourceUrl?: string;
  sessionId?: string;
}

export interface ZenAIQueryResponse {
  text: string;
  url?: string;
  metadata?: { [key: string]: unknown };
  sessionId?: string;
}

// Base streaming event interface
export interface ZenAIStreamEventBase {
  type: ZenAIStreamEventType;
}

// Specific streaming event types
export interface ZenAIReasoningEvent extends ZenAIStreamEventBase {
  type: ZenAIStreamEventType.Reasoning;
  text: string;
  accumulate: boolean;
}

export interface ZenAICompleteEvent extends ZenAIStreamEventBase {
  type: ZenAIStreamEventType.Complete;
  text: string;
  url?: string;
  sessionId?: string;
}

export interface ZenAIErrorEvent extends ZenAIStreamEventBase {
  type: ZenAIStreamEventType.Error;
  errorCode: string;
  message: string;
}

// Union type for all possible events (used in Observable streams)
export type ZenAIStreamEvent = ZenAIReasoningEvent | ZenAICompleteEvent | ZenAIErrorEvent;
